(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["instafeed-theme"] && !Shopify.designMode) return;
  try {
    (function cutbankInstafeedMarquee() {
  const COPY_FALLBACK = {
    eyebrow: '@cutbanksupplyco',
    view: 'View on Instagram'
  };

  function readCopy() {
    const node = document.getElementById('cutbank-ifs-copy');

    if (!node) return COPY_FALLBACK;

    try {
      const data = JSON.parse(node.textContent);

      return {
        eyebrow: typeof data.eyebrow === 'string' && data.eyebrow ? data.eyebrow : COPY_FALLBACK.eyebrow,
        view: typeof data.view === 'string' && data.view ? data.view : COPY_FALLBACK.view
      };
    } catch (error) {
      return COPY_FALLBACK;
    }
  }

  const copy = readCopy();

  function readPosts(block) {
    const script = block.querySelector('script[data-ifs-store-data]');

    if (!script) return [];

    try {
      const data = JSON.parse(script.textContent);

      return Array.isArray(data.posts) ? data.posts : [];
    } catch (error) {
      return [];
    }
  }

  function matchPost(posts, src) {
    if (!src) return null;

    const bare = src.split('?')[0];

    return (
      posts.find((post) => {
        if (!post || typeof post.mediaUrl !== 'string') return false;

        return bare === post.mediaUrl.split('?')[0] || bare.endsWith(post.mediaUrl.split('/').pop());
      }) || null
    );
  }

  function playIcon() {
    const icon = document.createElement('span');

    icon.className = 'ifs-video-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg>';

    return icon;
  }

  function labelTile(tile) {
    tile.classList.add('cutbank-ifs-tile');
    tile.setAttribute('aria-label', copy.view);
    tile.querySelectorAll('img').forEach((image) => {
      image.alt = '';
      image.setAttribute('draggable', 'false');
    });
  }

  function tileFromSlide(slide, posts) {
    const image = slide.querySelector('img');
    const video = slide.querySelector('video');
    const src = image?.getAttribute('src') || video?.getAttribute('poster') || video?.getAttribute('src') || '';
    const post = matchPost(posts, src);
    const shortcode = post && typeof post.shortcode === 'string' ? post.shortcode : '';
    const link = document.createElement('a');
    const still = document.createElement('img');

    link.className = 'cutbank-ifs-tile';
    link.href = shortcode
      ? `https://www.instagram.com/p/${encodeURIComponent(shortcode)}/`
      : 'https://www.instagram.com/cutbanksupplyco/';

    still.className = 'ifs-img';
    still.alt = '';
    still.decoding = 'async';
    still.loading = 'lazy';
    still.src = (post && post.mediaUrl) || src;
    still.width = 640;
    still.height = 800;
    still.setAttribute('draggable', 'false');
    link.append(still);

    const isVideo =
      (post && post.mediaType === 'VIDEO') ||
      slide.classList.contains('ifs-has-video') ||
      Boolean(slide.querySelector('.ifs-has-video, .ifs-video-icon'));

    if (isVideo) link.append(playIcon());

    return still.src ? link : null;
  }

  function onFocusIn(event) {
    const marquee = event.currentTarget;
    const tile = event.target.closest('.cutbank-ifs-tile');

    if (!tile || !tile.matches(':focus-visible')) return;
    if (tile.closest('[aria-hidden="true"]')) return;

    requestAnimationFrame(() => {
      const box = marquee.getBoundingClientRect();
      const tileBox = tile.getBoundingClientRect();
      const pad = 24;

      if (tileBox.left < box.left + pad || tileBox.right > box.right - pad) {
        marquee.scrollLeft += tileBox.left - box.left - pad;
      }
    });
  }

  function mount(feed, tiles) {
    if (!tiles.length || feed.querySelector('.cutbank-ifs-marquee')) return;

    const marquee = document.createElement('div');
    const track = document.createElement('div');
    const set = document.createElement('div');

    marquee.className = 'cutbank-ifs-marquee';
    track.className = 'cutbank-ifs-track';
    set.className = 'cutbank-ifs-set';

    tiles.forEach((tile) => {
      labelTile(tile);
      set.append(tile);
    });

    const duplicate = set.cloneNode(true);

    duplicate.setAttribute('aria-hidden', 'true');
    duplicate.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((node) => {
      node.tabIndex = -1;
    });
    duplicate.querySelectorAll('img').forEach((image) => {
      image.loading = 'lazy';
      image.removeAttribute('fetchpriority');
    });

    track.append(set, duplicate);
    marquee.append(track);
    marquee.addEventListener('focusin', onFocusIn);
    feed.append(marquee);
  }

  function ensureEyebrow(feeds) {
    const slot = feeds.querySelector('.ifs-title-row-text');

    if (!slot || slot.querySelector('.cutbank-ifs-eyebrow')) return;

    const eyebrow = document.createElement('span');

    eyebrow.className = 'cutbank-ifs-eyebrow';
    eyebrow.textContent = copy.eyebrow;
    slot.prepend(eyebrow);
  }

  function enhance(block, feeds) {
    ensureEyebrow(feeds);

    const feed = feeds.querySelector('.ifs-feed-block') || feeds;

    if (feed.querySelector('.cutbank-ifs-marquee')) return;

    const serverPosts = Array.from(feed.querySelectorAll('.ifs-ssr-post'));

    if (serverPosts.length) {
      mount(feed, serverPosts);
      return;
    }

    const posts = readPosts(block);
    const tiles = Array.from(feed.querySelectorAll('.ifs-slide'))
      .map((slide) => tileFromSlide(slide, posts))
      .filter(Boolean);

    mount(feed, tiles);
  }

  function setup(feeds) {
    if (feeds.dataset.cutbankIfsBound === 'true') return;

    feeds.dataset.cutbankIfsBound = 'true';

    const block = feeds.closest('.shopify-app-block') || feeds;
    let frame = 0;
    const run = () => enhance(block, feeds);

    run();

    const observer = new MutationObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(run);
    });

    observer.observe(block, { childList: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll('instagram-feeds').forEach(setup);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
